import React, {
  useState,
  useEffect,
} from 'react';
import {
  withRouter,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { Menu } from 'antd';
import { SpTab } from 'components/DesignKit';
import LynxConnectInvoices from './components/LynxConnectInvoices';
import LynxConnectLocations from './components/LynxConnectLocations';

type Props = {
  location: {
    pathname: string,
    search: string,
  },
  history: {
    push: Function,
    replace: Function,
    action: String,
  }
}

const LynxConnect = (props: Props) => {
  const {
    location,
  } = props;

  const [current, setCurrent] = useState('/lynxconnect/invoices');

  useEffect(() => {
    if (location) {
      // Treat /lynxconnect the same as /lynxconnect/invoices for UI purposes
      const currentPath = location.pathname === '/lynxconnect'
        ? '/lynxconnect/invoices'
        : location.pathname;
      setCurrent(currentPath ?? '/lynxconnect/invoices');
    }
  }, [location]);

  return (
    <div>
      <Menu
        onClick={e => setCurrent(e.key)}
        selectedKeys={[current]}
        mode="horizontal"
        style={{
          fontSize: '20px',
          marginBottom: '0px',
        }}
      >
        <Menu.Item key="/lynxconnect/invoices">
          <SpTab
            to="/lynxconnect/invoices"
            selected={current === '/lynxconnect/invoices'}
          >
            Invoices
          </SpTab>
        </Menu.Item>
        <Menu.Item key="/lynxconnect/locations">
          <SpTab
            to="/lynxconnect/locations"
            selected={current === '/lynxconnect/locations'}
          >
            Locations
          </SpTab>
        </Menu.Item>
      </Menu>
      <Switch>
        <Route exact path="/lynxconnect" render={() => <Redirect to="/lynxconnect/invoices" replace />} />
        <Route exact path="/lynxconnect/invoices" component={LynxConnectInvoices} />
        <Route exact path="/lynxconnect/locations" component={LynxConnectLocations} />
      </Switch>
    </div>
  );
};

// $FlowFixMe
export default withRouter(LynxConnect);
